import Block from "./Block";
import Navbar from "./Navbar";
import styles from "../css.module.css";
import { Slider } from "./Slider";
import { Carousel } from "./Craousel";
// import Flighthome from './components/Flighthome';
// import { Bookingcss } from './components/Bookingcss';
// import { Icondiv } from './components/Icondiv';
// import { Fromto } from './components/Fromto';
// import { Fare } from './components/Fare';
// import { Wrap } from './components/Wrap';
import { Home } from "./Home";
import "font-awesome/css/font-awesome.min.css";
import "./homepage.css";
import TrainSerch from "./TrainSerch";
function AllRoutes() {
  return (
    <>
      <div className="homeTop">
        <div className="homeTopCard">
          <div className="secondHeader"></div>

          <TrainSerch />
        </div>
      </div>
      <Block />
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <Slider />
        <div style={{ marginTop: 50 }}>
          <Carousel />
        </div>
      </div>
    </>
  );
}

export default AllRoutes;
